(()=>{
 if(customElements.get('mt-collection-rail'))return;
 class CollectionRail extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.track=this.querySelector('.mt-cr__track');this.items=[...this.querySelectorAll('.mt-cr__item')];
   this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
   this.prev.hidden=this.next.hidden=false;
   this.prev.setAttribute('aria-controls',this.track.id);this.next.setAttribute('aria-controls',this.track.id);
   this.abort=new AbortController();const on=(el,type,fn)=>el.addEventListener(type,fn,{signal:this.abort.signal});
   on(this.prev,'click',()=>this.go(-1));on(this.next,'click',()=>this.go(1));
   on(this.track,'keydown',e=>{if(e.target!==this.track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(e.key==='ArrowRight'?1:-1,true);}});
   on(this.track,'scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());});
   this.resize=new ResizeObserver(()=>this.update());this.resize.observe(this.track);this.update();
  }
  update(){
   const end=this.track.scrollWidth-this.track.clientWidth;
   this.prev.disabled=this.track.scrollLeft<=2;this.next.disabled=this.track.scrollLeft>=end-2;
   const left=this.track.getBoundingClientRect().left;
   const first=this.items.findIndex(e=>e.getBoundingClientRect().right>left+4);
   this.querySelector('[data-status]').textContent=`${this.dataset.label} models, starting with ${this.items[Math.max(0,first)].querySelector('h3').textContent}`;
  }
  go(direction,instant=false){
   const width=this.items[0].getBoundingClientRect().width;
   const gap=parseFloat(getComputedStyle(this.track).gap)||0;
   const visible=Math.max(1,Math.round((this.track.clientWidth+gap)/(width+gap)));
   const index=Math.round(this.track.scrollLeft/(width+gap));
   const next=Math.max(0,Math.min(this.items.length-visible,index+direction));
   this.track.scrollTo({left:next*(width+gap),behavior:instant||matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();cancelAnimationFrame(this.frame);this.ready=false;}
 }
 customElements.define('mt-collection-rail',CollectionRail);
})();
